'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseOrganizationProfileController=require('../../../../dist-es6/client/features/organizationProfile/baseOrganizationProfileController');
const{AvailableDataRetentionPeriods}=require('../../../../dist-es6/shared/domain/dataRetentionPeriod');let


OrganizationProfileController=class OrganizationProfileController extends BaseOrganizationProfileController{
static get $inject(){
return['$scope','$modal','$state','$timeout','breadcrumbsService','userService','socketService','uncaughtErrorHandler'];
}

constructor($scope,$modal,$state,$timeout,breadcrumbsService,userService,socketService,uncaughtErrorHandler){
super($state,$timeout,userService,socketService,uncaughtErrorHandler);

this._$modal=$modal;

if(_.get(userService,'currentUser.isPrimary')!==!0){
$state.go('fdc.features.profile');
return;
}

breadcrumbsService.startTrail('Organization Profile');

$scope.$watch('controller.initialLoadComplete',isComplete=>{
if(!isComplete)
return;

this._updateDataRetentionLabel();
});

this.availableDataRetentionPeriods=AvailableDataRetentionPeriods;
}

async _reloadProfileDataAndRetentionSettings(){
await this._reloadProfileData();
this._$timeout(()=>{
this._updateDataRetentionLabel();
});
}

_updateDataRetentionLabel(){
const currentRetentionPeriod=_.find(this.availableDataRetentionPeriods,{value:this.dataRetentionPeriodMs});

this._currentRetentionPeriod=currentRetentionPeriod;
this._currentDataRetentionLabel=_.exists(currentRetentionPeriod.numWeeks)?
`${currentRetentionPeriod.numWeeks} weeks (${currentRetentionPeriod.label})`:
currentRetentionPeriod.label;
}

editDataRetentionSetting(){
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/organizationProfile/components/editDataRetentionPeriodModalView',
controller:'EditDataRetentionPeriodModalController as controller',
resolve:{
selectedRetentionPeriod:()=>this._currentRetentionPeriod,
availableDataRetentionPeriods:()=>this.availableDataRetentionPeriods,
onRetentionPeriodUpdated:()=>this._reloadProfileDataAndRetentionSettings.bind(this)}});


}

get currentDataRetentionLabel(){
return this._currentDataRetentionLabel;
}};


module.exports=OrganizationProfileController;
//# sourceMappingURL=organizationProfileController.js.map
